import { FormControl, Input, InputLabel, makeStyles } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import MailOutline from "@material-ui/icons/MailOutline";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import PropTypes from "prop-types";
import CustomInput from "components/CustomInput/CustomInput";
import { travelApi } from "functions/apis";
import Datetime from "react-datetime";
import ControlGroupDialog from "components/ControlGroupDialog/ControlGroupDialog";
import { useParams } from "react-router-dom";

const useStyles = makeStyles(styles);

const ViewMerchantInventories = props => {
  const classes = useStyles();

  const [input, setInput] = useState({
    controlGroupID: null,
    date: null,
    currentBalance: 0
  });
  const [showModal, setShowModal] = useState(false);
  const [controlGroupData, setControlGroupData] = useState({
    id: "",
    name: ""
  });

  const { id } = useParams();

  const viewMerchantInventoriesSignal = useRef(new AbortController());

  useEffect(() => {
    travelApi
      .get("inventories/" + id, {
        signal: viewMerchantInventoriesSignal.current.signal
      })
      .then(resp => {
        setInput(resp);
        setControlGroupData({
          id: resp.controlGroup.id,
          name: resp.controlGroup.name
        });
      });
    return () => viewMerchantInventoriesSignal.current.abort();
  }, []);

  const handleDateChanged = e =>
    setInput({
      ...input,
      date: e === "" ? null : e
    });

  const handleCurrentBalanceChanged = e =>
    setInput({
      ...input,
      currentBalance: e.target.value === "" ? null : e.target.value
    });

  const handleControlGroupChanged = e => {
    setShowModal(false);
    setControlGroupData({
      id: e.id,
      name: e.name
    });
  };

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>VIEW MERCHANT INVENTORIES</h4>
          </CardHeader>
          <CardBody>
            <Button onClick={() => props.history.goBack()} value="Back">
              BACK
            </Button>
            <form>
              <GridItem>
                <FormControl
                  disabled
                  fullWidth
                  className={classes.selectFormControl}
                >
                  <InputLabel
                    htmlFor="selNationality"
                    className={classes.selectLabel}
                  >
                    Control Group
                  </InputLabel>
                  <Input
                    onClick={() => setShowModal(prev => !prev)}
                    className={classes.select}
                    value={controlGroupData.name ?? ""}
                    disabled
                  />
                  <ControlGroupDialog
                    openModal={showModal}
                    setOpenModal={val => setShowModal(val)}
                    onSelect={handleControlGroupChanged}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12}>
                <FormControl disabled fullWidth>
                  <Datetime
                    disabled
                    value={new Date(input.date)}
                    onChange={handleDateChanged}
                    timeFormat={true}
                    closeOnSelect={true}
                    inputProps={{
                      placeholder: "Effective Date",
                      disabled: true
                    }}
                  />
                </FormControl>
              </GridItem>
              <GridItem xs={12}>
                <CustomInput
                  labelText="Current Balance"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleCurrentBalanceChanged,
                    value: input.currentBalance,
                    type: "number",
                    disabled: true
                  }}
                />
              </GridItem>
            </form>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default ViewMerchantInventories;

ViewMerchantInventories.propTypes = {
  history: PropTypes.object
};
